import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { useIsVerifyingEmails } from '@aibees/elephant/feature/search-table-people/hooks/use-is-verifying-emails';
import { useCheckContactDetailsProcessing } from '@aibees/elephant/hooks/people/use-check-contact-details-processing';
import { useCheckEmailEnrichmentProcessing } from '@aibees/elephant/hooks/people/use-check-email-enrichment-processing';
import { useCheckPeoplePhoneNumberProcessing } from '@aibees/elephant/hooks/people/use-check-people-phone-number-processing';
import { useCheckPersonalityAnalysisProcessing } from '@aibees/elephant/hooks/people/use-check-personality-analysis-processing';
import { useContactDetailsLoading } from '@aibees/elephant/hooks/people/use-contact-details-loading';
import { usePeoplePhoneNumberLoading } from '@aibees/elephant/hooks/people/use-people-phone-number-loading';
import { usePersonalityAnalysisLoading } from '@aibees/elephant/hooks/people/use-personality-analysis-loading';
import { useIsItemSaving } from '@aibees/elephant/hooks/use-is-item-saving';

export function useIsPeopleUnlockButtonLoading(item?: PeopleTableInfo) {
  useCheckContactDetailsProcessing(item);
  useCheckPersonalityAnalysisProcessing(item);
  useCheckEmailEnrichmentProcessing(item);
  useCheckPeoplePhoneNumberProcessing(item);

  const { isVerifying: emailLoading } = useIsVerifyingEmails(item);
  const { loading: personalityLoading } = usePersonalityAnalysisLoading(item);
  const { loading: loadingContactDetails } = useContactDetailsLoading(item);
  const { loading: loadingPhoneNumber } = usePeoplePhoneNumberLoading(item);
  const { saving } = useIsItemSaving(item);

  return {
    personalityLoading,
    loadingContactDetails,
    loadingPhoneNumber,
    emailLoading,
    saving,
  };
}
